import getPlansByCustomRules from 'core/services/getPlansByProductId/get-plans-by-custom-rules'
import retryToUpdateStartDate from 'core/services/getPlansByProductId/retryToUpdateStartDate'
import getStmAndBtm from 'core/services/getPlansByProductId/getSTMandBTM' // cspell:disable-line
import setBTMEligibility from 'core/controllerPlans/setBTMEligibility'

import getSTM from 'core/services/getPlansByProductId/getSTM'
import curry from 'utils/functional/curry'
import isBTMDisabled from 'core/controllerPlansBTM/isBTMDisabled'
import { SURE_CARE } from 'core/constants/products'
import { propAccessor } from '@hc-frontend/utils'
import { IS_ENROLL } from 'core/constants/environment'

function getPlansHandler(state) {
  return state.BTMEligibility ? getStmAndBtm(state) : getSTM(state)
}

export function getSTMBTM(state) {
  return setBTMEligibility(state).then(getPlansHandler)
}

function getPlans(state) {
  const plansPromise = isBTMDisabled() ? getSTM(state) : getSTMBTM(state)

  return plansPromise.then(curry(retryToUpdateStartDate)(getPlansHandler))
}

function getPlansEnrollHandler(state) {
  const stateAcronym = propAccessor(state, 'hcStorage.location.state_acronym')

  return getPlansByCustomRules(state, {
    [SURE_CARE]: !(IS_ENROLL && stateAcronym === 'ND')
  })
}

export function getPlansEnroll(state) {
  return getPlansEnrollHandler(state).then(
    curry(retryToUpdateStartDate)(getPlansEnrollHandler)
  )
}

export default getPlans
